import { computed, Inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { AbstractConfigService, CONFIG_SERVICE_INJECTOR } from '@campaign-portal/components-library';
import { AppInfoProvider } from '@campaign-portal/contracts/app-info';

const LOGO_LIGHT = 'assets/img/sidebar-logo.png';
const LOGO_DARK = 'assets/img/sidebar-logo-contrast.png';
const COMPANY_NAME = 'Alaris Labs';

@Injectable({ providedIn: 'root' })
export class AlarisAppInfoAdapter extends AppInfoProvider {
	readonly companyName = COMPANY_NAME;
	readonly logo: Signal<string>;

	constructor(@Inject(CONFIG_SERVICE_INJECTOR) private readonly config: AbstractConfigService) {
		super();
		const themeType = toSignal(this.config.themeType$, { initialValue: this.config.themeType$.getValue() });
		this.logo = computed(() => (themeType() === 'dark' ? LOGO_DARK : LOGO_LIGHT));
	}

	get version(): string {
		return this.config.version;
	}

	get releaseDate(): string {
		return this.config.releaseDate;
	}

	get termsUrl(): string | null {
		return this.config.termsUrl || null;
	}

	get privacyUrl(): string | null {
		return this.config.privacyUrl || null;
	}
}
